import {useSelector} from 'react-redux';

import {UserTariffCountKey} from './IUser';
import {userSelector} from './authSlice';

const useHasTariffLimit = (field: UserTariffCountKey): boolean => {
    const user = useSelector(userSelector);

    if (!user) {
        return false;
    }

    return (user.tariff[field] ?? 0) > 0;
};

export default useHasTariffLimit;
